export default __webpack_public_path__ + "static/media/Autodesk.1b9fe7cc.png";